import { Box, CircularProgress, Typography } from "@mui/material";

const LoadingSpinner = ({ text = "Loading..." }) => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 1.5
      }}
    >
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        {text}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
